export * from './create-widget/create-widget.component';
export * from './interval-wrapper/interval-wrapper.component';
export * from './widgets/widgets.component';
export * from "./widget-chart/widget-chart.component";